<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep-bot">‘Letters are like wine; if they are sound they ripen with keeping’</p>
<p class="epc">S<span class="epub-sc">AMUEL</span> B<span class="epub-sc">UTLER</span></p>
<p class="txs"> </p>
<p class="ep-bot">‘Sometimes, one’s heart quails at the thought of the things that lie ahead, and then one counts one’s blessings – and things don’t seem so bad!’</p>
<p class="epc">T<span class="epub-sc">HE</span> Q<span class="epub-sc">UEEN</span>,</p>
<p class="epc">5 May 1939 to the Archbishop of Canterbury</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?e2d28918